
import TEditor from '@/components/editor/TEditor.vue';
import { ElMessage } from "element-plus";
import { getEnum } from "@/api/index";
import { useRouter, useRoute } from "vue-router";
import {putNwes, getNewsInfo} from "@/api/backstage";
import type { ElForm } from "element-plus";
import Uploadimg from "@/components/uploadimg/Index.vue";
import Uploadfile from "@/components/uploadfile/Index.vue";
import { useStore } from "vuex";
type FormInstance = InstanceType<typeof ElForm>;
 
import {
  defineComponent,
  reactive,
  computed,
  ref,
  unref,
  toRefs,
  watch,
  onMounted,
} from "vue";
export default defineComponent({
  name: "新增新闻",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
  components: {
    Uploadimg,Uploadfile,TEditor,
  },
 
  setup(opt, contex) {
    const store = useStore();
    let isEdit = false;
    let show = opt.open;
    const router = useRouter();
    const route = useRoute();
    const dataMap: any = reactive({
      ruleFormRef: ref<FormInstance>(),
      sex: {},
      pushTime:'',
      newsType:{},
      status:{},
      ruleForm: {
        title: "",
        newsType: "",
        isTop: false,
        summary:'',
        content: "",
        status: '',
        fileId: "",
        fileIds: [],
        userId:localStorage.getItem('userId'),
      },
      rules: {
        title: [
          { required: true, message: "请输标题", trigger: "blur" },
        ],
        status: [
          { required: true, message: "请选择状态", trigger: "blur" },
        ],
        newsType: [
          { required: true, message: "请选择新闻类型", trigger: "blur" },
        ],
        content: [{ required: true, message: "请输入内容", trigger: "blur" }],
      },

      async getNewsType() {
        dataMap.newsType = {};
        const menus = await getEnum("NEWS");
        for (const item of menus.data) {
          dataMap.newsType[item.enumKey] = item;
        }
      },
      async getStatus() {
        dataMap.status = {};
        const menus = await getEnum("STATUS");
        for (const item of menus.data) {
          dataMap.status[item.enumKey] = item;
        }
      },
      async getNwes() {
        const res = await getNewsInfo(route.query.id);
        dataMap.ruleForm = res.data;
        delete  dataMap.ruleForm.createTime;
        dataMap.ruleForm.isTop ===  1
          ? (dataMap.ruleForm.isTop = true)
          : (dataMap.ruleForm.isTop = false);
        if( dataMap.ruleForm.fileName) dataMap.ruleForm.fileUrl = localStorage.getItem("fileUrel") + dataMap.ruleForm.fileName;
      },

      async putNwes() {
        let query: any = JSON.parse(JSON.stringify(dataMap.ruleForm));
        query.isTop? (query.isTop = 1) : (query.isTop =0);
        const res = await putNwes(query);
        if (res.code === 200) {
          ElMessage({
            message: "操作成功",
            type: "success",
          });
          router.go(-1);
        } else {
          ElMessage({
            message: res.msg,
            type: "error",
          });
        }
      },
    });

    if (opt.row) {
      isEdit = true;
      dataMap.ruleForm = opt.row;
    }

    const onSuccess = (val: any) => {
      dataMap.ruleForm.fileId = val.id;
    };

    const fileSuccess = (val: any) => {
      dataMap.ruleForm.fileIds = [];
      for(const item of val.value) {
        dataMap.ruleForm.fileIds.push(item.id);
      }
    };
  
    const submitForm = (formEl: FormInstance | undefined) => {
      if (!formEl) return;
      formEl.validate((valid) => {
        if (valid) {
          dataMap.putNwes();
        } else {
          console.log("error submit!");
          return false;
        }
      });
    };

    onMounted(() => {
      if (route.query.id) dataMap.getNwes();
      dataMap.getNewsType();
      dataMap.getStatus();
    });

    return {
      show,
      store,
      isEdit,
      router,
      submitForm,
      close,
      route,
      onSuccess,
      fileSuccess,
      ...toRefs(dataMap),
    };
  },
});
